// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1QvXx","notes":"Notes_notes__2Kn8s"};